// temp disable travel distance request on all but initial spots
//import {getTravelDistances} from './spots-actions';

export const UPDATE_SELECTED_SPOT = 'UPDATE_SELECTED_SPOT';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SET_SORT_TYPE = 'SET_SORT_TYPE';
export const SET_NEW_LOCATION = 'SET_NEW_LOCATION';
export const UPDATE_SEARCH_TIMES = 'UPDATE_SEARCH_TIMES';
export const TOGGLE_LIST_VIEW = 'TOGGLE_LIST_VIEW';
export const TOGGLE_INFO_PANEL_VIEW = 'TOGGLE_INFO_PANEL_VIEW';
export const TOGGLE_FILTERS_VIEW = 'TOGGLE_FILTERS_VIEW';
export const SET_SEARCH_MAP_INSTANCE = 'SET_SEARCH_MAP_INSTANCE';
export const SET_ZOOM = 'SET_ZOOM';

export const updateSelectedSpot = (spot, referrer) => {
    return {
        type: UPDATE_SELECTED_SPOT,
        payload: {
            spot,
            referrer
        }
    };
};

export const setSearchTerm = term => {
    return {
        type: SET_SEARCH_TERM,
        payload: {
            isMonthly: (term === 'monthly')
        }
    };
};

export const setSortType = sortBy => {
    return dispatch => {
        dispatch({
            type: SET_SORT_TYPE,
            payload: {
                sortBy
            }
        });

        // temp disable travel distance request on all but initial spots
        // getTravelDistances(dispatch)
        //     .catch(error => {
        //         // silently catch this error to ignore errors being logged
        //     });
    };
};

export const setNewLocation = ({latitude, longitude, title, geolocated = false}) => {
    return {
        type: SET_NEW_LOCATION,
        payload: {
            latitude,
            longitude,
            title,
            geolocated
        }
    };
};

export const updateSearchTimes = ({transientStarts, transientEnds, monthlyStarts}) => {
    return {
        type: UPDATE_SEARCH_TIMES,
        payload: {
            starts: transientStarts,
            ends: transientEnds,
            monthly_start_date: monthlyStarts
        }
    };
};

export const toggleListView = () => {
    return {
        type: TOGGLE_LIST_VIEW
    };
};

export const toggleInfoPanelView = isInfoPanelVisible => {
    return {
        type: TOGGLE_INFO_PANEL_VIEW,
        payload: {
            isInfoPanelVisible
        }
    };
};

export const toggleFiltersView = () => {
    return {
        type: TOGGLE_FILTERS_VIEW
    };
};

export const setSearchMapInstance = searchMapInstance => {
    return {
        type: SET_SEARCH_MAP_INSTANCE,
        payload: {
            searchMapInstance
        }
    };
};

export const setZoom = zoom => {
    return {
        type: SET_ZOOM,
        payload: {
            zoom
        }
    };
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/search/common/search-actions.js